import React, { useEffect, useState } from "react";
import { API_URL } from "../../../config";
import STLPreview from "./StlPreview";
import { StyledDialog } from "../../../common/components/Dialog";
import Spinner from "../../../common/components/Spinner";
import { LinearProgress } from "@mui/material";
import { DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { StyledButton } from "../../../common/components/Button";
import ImagePreview from "./ImagePreview";
const FilePreviewDialog = ({
  openFilePreview,
  handleCloseFilePreview,
  url,
  filename,
}) => {
  const [blobLink, setBlobLink] = useState(null);
  const [loading, setLoading] = useState(false);

  const [fileType, setFileType] = useState("");

  function getExtension(filename) {
    let filename_lower = filename.toLowerCase();
    var parts = filename_lower.split(".");
    setFileType(parts[parts.length - 1]);
  }
  useEffect(() => {
    setLoading(true);
    getExtension(filename);

    const getFile = async () => {
      try {
        fetch(url).then((response) => {
          response.blob().then((blob) => {
            let url = window.URL.createObjectURL(blob);
            setBlobLink(url);
            console.log(url);
            setLoading(false);
          });
        });
      } catch (err) {
        console.log(err);
      }
    };

    getFile();
  }, [url]);

  return (
    <StyledDialog
      open={openFilePreview}
      onClose={handleCloseFilePreview}
      width={"1000px"}
      maxWidth="md"
      style={{ padding: "0px 0px 0px 0px" }}
    >
      {loading && (
        <LinearProgress height={14} borderRadius="16px" color="primary" />
      )}
      <DialogTitle style={{ fontFamily: "Inter", fontWeight: 600 }}>
        {filename}
      </DialogTitle>
      <DialogContent>
        {!loading && blobLink && fileType === "stl" && (
          <STLPreview link={blobLink} />
        )}
        {!loading &&
          blobLink &&
          (fileType === "png" || fileType === "jpg" || fileType === "jpeg") && (
            <ImagePreview filename={filename} link={blobLink} />
          )}
      </DialogContent>
      <DialogActions>
        <StyledButton theme="green" onClick={handleCloseFilePreview}>
          Close
        </StyledButton>
      </DialogActions>
    </StyledDialog>
  );
};

export default FilePreviewDialog;
